import { RentalPortalListingProfileDocuments } from '../RentalPortalListingProfileDocuments'
import { RentalPortalListingProfileExpose } from '../RentalPortalListingProfileExpose'
import { RentalPortalListingProfilePublishings } from '../RentalPortalListingProfilePublishings'
import { RentalPortalListingProfileUpdates } from '../RentalPortalListingProfileUpdates'

export const LISTING_PROFILE_TAB_DOCUMENTS = 'documents'

export const LISTING_PROFILE_TAB_OVERVIEW = 'overview'

export const LISTING_PROFILE_TAB_PUBLISHINGS = 'publishings'

export const LISTING_PROFILE_TAB_UPDATES = 'updates'

export const QA_NAME_LISTING_PROFILE_TAB_DOCUMENTS =
  'listingProfileDocumentsTab'

export const QA_NAME_LISTING_PROFILE_TAB_OVERVIEW = 'listingProfileOverviewTab'

export const QA_NAME_LISTING_PROFILE_TAB_PUBLISHINGS =
  'listingProfilePublishingsTab'

export const QA_NAME_LISTING_PROFILE_TAB_UPDATES = 'listingProfileUpdatesTab'

export const LISTING_PROFILE_TAB_LIST = [
  {
    Content: RentalPortalListingProfileExpose,
    id: LISTING_PROFILE_TAB_OVERVIEW,
    qaName: QA_NAME_LISTING_PROFILE_TAB_OVERVIEW,
    titleKey: 'RentalPortal.ListingProfileTabOverviewKey',
  },
  {
    Content: RentalPortalListingProfilePublishings,
    counterSection: LISTING_PROFILE_TAB_PUBLISHINGS,
    id: LISTING_PROFILE_TAB_PUBLISHINGS,
    permissionKey: 'can_view_publications',
    qaName: QA_NAME_LISTING_PROFILE_TAB_PUBLISHINGS,
    titleKey: 'RentalPortal.ListingProfileTabPublishingsKey',
  },
  {
    Content: RentalPortalListingProfileDocuments,
    counterSection: LISTING_PROFILE_TAB_DOCUMENTS,
    id: LISTING_PROFILE_TAB_DOCUMENTS,
    permissionKey: 'can_view_documents',
    qaName: QA_NAME_LISTING_PROFILE_TAB_DOCUMENTS,
    titleKey: 'RentalPortal.ListingProfileTabDocumentsKey',
  },
  {
    Content: RentalPortalListingProfileUpdates,
    id: LISTING_PROFILE_TAB_UPDATES,
    permissionKey: 'can_view_updates',
    qaName: QA_NAME_LISTING_PROFILE_TAB_UPDATES,
    titleKey: 'RentalPortal.ListingProfileTabUpdatesKey',
  },
]
